import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

export default function Imprint() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-brand-black pt-32 pb-20 px-6"
    >
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-brand-gold/60 hover:text-brand-gold text-xs tracking-widest uppercase mb-12 transition-colors group"
        >
          <SafeIcon icon={FiArrowLeft} className="group-hover:-translate-x-1 transition-transform" />
          {t.backHome}
        </Link>

        <h1 className="font-serif text-4xl md:text-5xl text-white mb-12 tracking-wide">
          {t.legal.title}
        </h1>

        <div className="space-y-8 text-white/70 font-sans leading-relaxed text-sm md:text-base">
          <section className="border-l border-brand-gold/20 pl-6 py-2">
            <p className="font-medium text-white mb-1">{t.legal.responsible}</p>
            <p>{t.legal.address}</p>
          </section>

          <section className="border-l border-brand-gold/20 pl-6 py-2">
            <p className="text-white mb-1 uppercase tracking-widest text-xs font-bold">{t.imprintLink}</p>
            <p>{t.legal.contact}</p>
            <p>{t.legal.tax}</p>
          </section>

          <section className="border-l border-brand-gold/20 pl-6 py-2">
            <p className="text-white mb-1 uppercase tracking-widest text-xs font-bold">Dispute Resolution</p>
            <p className="text-white/50 italic text-sm">
              {t.legal.dispute}
            </p>
          </section>
        </div>

        <div className="mt-20 pt-10 border-t border-white/5">
          <p className="font-serif text-xl tracking-ultra-wide text-brand-gold/40">
            METANOIA
          </p>
        </div>
      </div>
    </motion.div>
  );
}